export default __webpack_public_path__ + "static/media/pavel_xl.c4822825.jpg";